import Button from "components/Button";
import MaskedInput from "components/MaskedInput";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import { ChangeEvent, Fragment, useMemo, useState } from "react";
import * as S from "./styles";
import { SelectOption } from "../AttachmentsTab/data";
import Select from "components/Select";
import * as messages from "utils/whatsappMessageTemplates";

type TemplateValues = "furto" | "roubo" | "patrimonial";

const selectData: SelectOption<TemplateValues>[] = [
  { label: "Furto", value: "furto" },
  { label: "Roubo", value: "roubo" },
  { label: "Patrimonial", value: "patrimonial" },
];

function TemplateMessageWithLineBreaks({ message }: { message: string }) {
  const lines = message.replaceAll("*", "").split("\n");

  // Map each line to a JSX element with a <br /> tag
  const elements = lines.map((line, index) => (
    <Fragment key={index}>
      {line}
      {index !== lines.length - 1 && <br />}
    </Fragment>
  ));

  return <>{elements}</>;
}

export default function WhatsappTab() {
  const [selectedTemplate, setSelectedTemplate] = useState<TemplateValues | "">(
    ""
  );
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const { occurrenceToEdit } = useManualOccurrence();

  const messagePreview = useMemo(() => {
    if (!selectedTemplate)
      return "Selecione um template para visualizar a previa da mensagem";

    if (selectedTemplate === "furto") {
      return messages.theftTemplate(occurrenceToEdit);
    }

    if (selectedTemplate === "patrimonial") {
      return messages.patrimonialTemplate(occurrenceToEdit);
    }

    if (selectedTemplate === "roubo") {
      return messages.stealTemplate(occurrenceToEdit);
    }
  }, [selectedTemplate, occurrenceToEdit]);

  async function openWhatsappWithPreviewMessage() {
    const formattedPhoneNumber = phoneNumber.replace(/[^\d]/g, "");
    const encodedMessage = encodeURIComponent(messagePreview as string);
    const messageWithLineBreaks = encodedMessage
      .replace(/%20/g, "+")
      .replace(/%0A/g, "%0D%0A");

    const URL = "https://web.whatsapp.com/";
    const ENDPOINT = "send/";
    const QUERY_PARAMS = `?phone=${formattedPhoneNumber}&text=${messageWithLineBreaks}&type=phone_number&app_absent=0`;

    const API_URL = `${URL}${ENDPOINT}${QUERY_PARAMS}`;

    window.open(API_URL);
  }

  return (
    <S.Wrapper>
      <Select
        label="Selecione um template de mensagem"
        id="message-template"
        name="message-template"
        required
        onChange={(event) =>
          setSelectedTemplate(event.target.value as TemplateValues)
        }
      >
        <option value="">Nenhum</option>
        {selectData.map((option) => (
          <option value={option.value}>{option.label}</option>
        ))}
      </Select>

      <MaskedInput
        id="phoneNumber"
        mask="+55 (99) 9 9999-9999"
        label="Digite o numero para envio da mensagem"
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          setPhoneNumber(event.target.value)
        }
      />

      <S.Preview>
        <h3>Pré-visualização da mensagem</h3>

        <TemplateMessageWithLineBreaks message={messagePreview as string} />

        {!selectedTemplate && (
          <S.Disclaimer>
            <strong>Atenção!</strong> Caso algum dado esteja em branco,
            significa que o apoio é avulso e não consta em nossa base de dados.
            Nesse caso, preencha manualmente os dados na hora do envio da
            mensagem.
          </S.Disclaimer>
        )}
      </S.Preview>

      <Button
        title="Ir para o WhatsApp"
        type="button"
        onClick={openWhatsappWithPreviewMessage}
      />
    </S.Wrapper>
  );
}
